import * as UpChunk from '@mux/upchunk';

export const handlePartialUpload = (file, url, progressFunction = null) => {
  console.log(url);
  console.log(file);
  return new Promise((resolve, reject) => {
    const headers = new Headers();
    headers.append('Content-Type', file.type);
    const upload = UpChunk.createUpload({
      endpoint: url,
      file,
      headers,
    });
    upload.on('error', err => {
      console.error('Error uploading video', err.detail);
      reject(err);
    });
    
    upload.on('progress', progress => {
      if (progress.detail < 80) {
        progressFunction && progressFunction(progress.detail);
      }
    });

    upload.on('success', () => {
      progressFunction && progressFunction(85);
      resolve();
    });
  });
};



